export enum ENUM_TOASTIFY{
    INTRODUCE=0,
    WARNING=1,
    SUCCESS=2,
    ERROR=3
}   